import { computed, ref } from 'vue'
import numbro from 'numbro'
import numbroLanguages from 'numbro/dist/languages.min'
import { createI18n, useI18n } from 'vue-i18n'
import { persistentSettings } from '../shared/local-storage'

import en from './locales/en.yaml'
import cs from './locales/cs.yaml'
import nl from './locales/nl.yaml'
import pl from './locales/pl.yaml'

export const locales = {
  en: 'English',
  cs: 'Česky',
  nl: 'Nederlands',
  pl: 'Polski'
}

export const localeCountryCodes = {
  en: 'gb',
  cs: 'cz',
  nl: 'nl',
  pl: 'pl'
}

Object.values(numbroLanguages).forEach(language => numbro.registerLanguage(language))

const getUserLanguage = () => window.navigator.language

const coerceUserLanguage = userLanguage =>
  Object.keys(locales)
    .find(locale => userLanguage.startsWith(locale)) ?? Object.keys(locales)[0]

const getStoredLanguage = () => persistentSettings.value.language

const setStoredLanguage = language => {
  persistentSettings.value.language = language
}

const setupNumbro = userLanguage => {
  const language = Object.keys(numbro.languages()).find(supportedLanguage => supportedLanguage.startsWith(userLanguage))
  if (language) {
    numbro.setLanguage(language)
  }
  // console.log('i18n.js setupNumbro', { userLanguage, language, used: numbro.language() })
}

const setupVueI18n = () => createI18n({
  fallbackLocale: 'en',
  messages: { en, cs, nl, pl }
})

let vueI18n

const getPreferredLanguage = () => getStoredLanguage() ?? coerceUserLanguage(getUserLanguage())

export const initI18n = () => {
  const userLanguage = getPreferredLanguage()
  // console.log('i18n.js initI18n', { userLanguage })

  setupNumbro(userLanguage)
  vueI18n = setupVueI18n()
  setI18nLanguage(userLanguage)

  return vueI18n
}

const currentLocaleRef = ref()

export const currentLocale = computed(() => currentLocaleRef.value)

export const setI18nLanguage = language => {
  vueI18n.global.locale.value = language
  currentLocaleRef.value = language
  setStoredLanguage(language)
  document.querySelector('html').setAttribute('lang', language)
}

export const tl = prefix => {
  const { t } = useI18n()
  return (code, ...rest) => t(`${prefix}.${code}`, ...rest)
}
